import { DataService } from '../services/data.service';
import { from, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { SharedService } from '../services/shared.service';
import { User } from '../models/user';
import {
  catchError,
  first,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private router: Router,
    private shared: SharedService,
    private loadingService: LoadingService,
    private data: DataService
  ) {
    this.initializeStorage();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.loadingService.loading$.next(true);
    return this.shared.user$.pipe(
      first(),
      switchMap(user => {
        if (user) {
          return of(user);
        } else {
          return from(this.shared.storage.get('auth')).pipe(
            switchMap(auth => {
              if (auth) {
                this.shared.access_token = auth.access_token;
                this.shared.refresh_token = auth.refresh_token;
                return this.shared.get('profile/me').pipe(
                  map((res) => res.data),
                  catchError(() => of(null as User))
                );
              } else {
                return of(null as User);
              }
            })
          );
        }
      }),
      switchMap(user => {
        if (user || this.shared.web) {
          this.shared.user$.next(user as User);
          return this.loadDataAndNavigate();
        } else {
          this.router.navigateByUrl('/tabs/home');
          return of(false);
        }
      })
    );
  }

  private loadDataAndNavigate(): Observable<boolean> {
    return this.data.loadData().pipe(
      tap(() => {
        this.loadingService.loading$.next(false);
      }),
      map(() => true),
      catchError((err) => {
                
        this.router.navigateByUrl('/tabs/home');
        return of(false);
      })
    );
  }

  async initializeStorage() {
    await this.shared.storage.init();
  }
}
